import "./App.css";
import store from "./stores/store";
import { useSelector } from "react-redux";
import { useEffect } from "react";
import LayerTree from "./components/layerTree/LayerTree";
import { walk } from "react-sortable-tree";
import {
  appInit,
  buildAppURL,
  fetch,
  fetchLayersRequest,
  fetchSourceResponseFormatter,
  getURLPath,
  layerResponseFormatter,
  registerLayerRequest,
  trans,
  updateLayerPropertiesFromConfig,
} from "./lib/utils";
import Map from "./components/map/Map";
import ModalComponent from "./components/modal/modalComponent";
import ResultsPanel from "./components/resultsPanel/ResultsPanel";
import LeftPanel from "./components/leftPanel/LeftPanel";
import "./lib/scripts.js";
import { Resizable } from "react-quick-resizable";
import { Route, Link, Routes, useLocation } from "react-router-dom";
import FileExplorerComponent from "./components/fileExplorer/fileExplorerComponent";
import Joyride from "react-joyride";
import { createBrowserHistory } from "history";
import parse from "html-react-parser";

const history = createBrowserHistory();

function App(props) {
  const layerTree = useSelector((state) => store.getState().layerTree);
  const layers = useSelector((state) => store.getState().layers);
  const registeredLayerTree = useSelector(
    (state) => store.getState().registeredLayerTree.tree
  );
  const guideTour = useSelector((state) => store.getState().app.guideTour);

  const unsubscribe = store.subscribe(() => {
    console.log("State after dispatch: ", store.getState());
    unsubscribe();
  });

  useEffect(() => {
    if (window["appConfig"]) {
      appInit(layerTree, registeredLayerTree);

      if (window["appConfig"]()["welcomeMessage"]()) {
        window["primaryModal"].setState({
          title: "",
          size: "large",
          show: true,
          body: parse(window["appConfig"]()["welcomeMessage"]()),
        });
      }
    }
    // init();
    window["recaclulatePerfectScrollbarHeight"]();

    window.addEventListener(
      "resize",
      window["recaclulatePerfectScrollbarHeight"]
    );
  }, []);

  // const init = () => {
  //   if (window["appConfig"]) {
  //     //Layer tree
  //     const registerSources = [];
  //     const registerSourcesURL = [];
  //     const layerTreeIds = [];

  //     walk({
  //       treeData: layerTree,
  //       getNodeKey: ({ treeIndex }) => treeIndex,
  //       ignoreCollapsed: false,
  //       callback: (rowInfoIter) => {
  //         const node = rowInfoIter.node;
  //         switch (node.type) {
  //           case "layer":
  //             if (registerSourcesURL.indexOf(node.layer.source.url) < 0) {
  //               registerSources.push(fetchLayersRequest(node.layer.source));
  //               registerSourcesURL.push(node.layer.source.url);
  //             }
  //             layerTreeIds.push(node.id);
  //             break;
  //         }
  //       },
  //     });

  //     fetch(
  //       window["appConfig"]()["api"](),
  //       "POST",
  //       {},
  //       registerSources,
  //       (resp) => {
  //         const sources = fetchSourceResponseFormatter(resp.data);

  //         store.dispatch({ type: "source/add", payload: sources });

  //         let allLayers = {};

  //         resp.data?.forEach((el) => {
  //           el._response._layers?.forEach((layer) => {
  //             if (layerTreeIds.indexOf(layer._layerId) >= 0) {
  //               allLayers[layer._layerId] = updateLayerPropertiesFromConfig(
  //                 layerResponseFormatter(layer),
  //                 layerTree
  //               );
  //               allLayers[layer._layerId].source = {
  //                 id: el._response._serviceId,
  //                 url: el._response._serviceUrl,
  //                 type: el._response._serviceType,
  //               };
  //               allLayers[layer._layerId].loaded = true;

  //               fetch(
  //                 window["appConfig"]()["api"](),
  //                 "POST",
  //                 {},
  //                 [registerLayerRequest(allLayers[layer._layerId])],
  //                 (lresp) => {
  //                   let lresponse = layerResponseFormatter(
  //                     lresp.data[0]._response
  //                   );

  //                   let newLayer = { ...allLayers[layer._layerId] };

  //                   if (newLayer["attributes"].length < 1) {
  //                     store.dispatch({
  //                       type: "layer/update",
  //                       payload: {
  //                         id: layer._layerId,
  //                         property: "attributes",
  //                         value: lresponse.attributes,
  //                       },
  //                     });
  //                   }

  //                   Object.keys(newLayer).forEach((el) => {
  //                     if (!newLayer[el]) {
  //                       if (lresponse[el]) {
  //                         store.dispatch({
  //                           type: "layer/update",
  //                           payload: {
  //                             id: layer._layerId,
  //                             property: el,
  //                             value: lresponse[el],
  //                           },
  //                         });
  //                       }
  //                     }
  //                   });
  //                 }
  //               );
  //             }
  //           });
  //         });

  //         store.dispatch({ type: "layer/state/update", payload: allLayers });
  //       }
  //     );

  //     const registeredLayerTreeIds = [];

  //     walk({
  //       treeData: registeredLayerTree,
  //       getNodeKey: ({ treeIndex }) => treeIndex,
  //       ignoreCollapsed: false,
  //       callback: (rowInfoIter) => {
  //         const node = rowInfoIter.node;
  //         switch (node.type) {
  //           case "layer":
  //             if (registerSourcesURL.indexOf(node.layer.source.url) < 0) {
  //               registerSources.push(fetchLayersRequest(node.layer.source));
  //               registerSourcesURL.push(node.layer.source.url);
  //             }
  //             registeredLayerTreeIds.push(node.id);
  //             break;
  //         }
  //       },
  //     });

  //     fetch(
  //       window["appConfig"]()["api"](),
  //       "POST",
  //       {},
  //       registerSources,
  //       (resp) => {
  //         const sources = fetchSourceResponseFormatter(resp.data);

  //         store.dispatch({ type: "source/add", payload: sources });

  //         let allLayers = {};

  //         resp.data?.forEach((el) => {
  //           el._response._layers?.forEach((layer) => {
  //             if (registeredLayerTreeIds.indexOf(layer._layerId) >= 0) {
  //               allLayers[layer._layerId] = updateLayerPropertiesFromConfig(
  //                 layerResponseFormatter(layer),
  //                 registeredLayerTree
  //               );
  //               allLayers[layer._layerId].source = {
  //                 id: el._response._serviceId,
  //                 url: el._response._serviceUrl,
  //                 type: el._response._serviceType,
  //               };
  //               allLayers[layer._layerId].loaded = true;
  //             }
  //           });
  //         });

  //         store.dispatch({
  //           type: "registeredLayerTree/state/layers/update",
  //           payload: allLayers,
  //         });
  //       }
  //     );
  //   }
  // };

  return (
    <>
      <header>
        <nav
          className="navbar navbar-expand p-0 border-bottom-1 border scroll-x p-0"
          draggable="false"
        >
          <nav className="navbar navbar-expand-md top-navbar ps-2">
            <div className="container-fluid viewport-padding">
              <span className="mb-0">
                <img
                  src="https://www.getmap.eu/wp-content/uploads/2016/05/GET-SDI-PORTAL_sh.png"
                  height="38px"
                />
              </span>
            </div>
          </nav>

          <div className="container-fluid viewport-padding" draggable="false">
            <ul
              className="navbar-nav nav-tabs border-bottom-0"
              draggable="false"
              role="tablist"
            >
              <li
                className="nav-item"
                onClick={() => {
                  history.push(buildAppURL(""));
                }}
              >
                <span
                  className={"nav-link ".concat(!getURLPath(1) ? "active" : "")}
                  data-bs-toggle="tab"
                  data-bs-target="#map-tab"
                  role="button"
                >
                  <small>{trans("Map")}</small>
                </span>
              </li>
              <li
                className="nav-item"
                onClick={() => {
                  history.push(buildAppURL("files"));
                }}
              >
                <span
                  className={"nav-link ".concat(
                    getURLPath(1) == "files" ? "active" : ""
                  )}
                  data-bs-toggle="tab"
                  data-bs-target="#file-tab"
                  role="button"
                >
                  <small>{trans("Files")}</small>
                </span>
              </li>
              <li className="nav-item">
                <span
                  className="nav-link"
                  data-bs-toggle="tab"
                  data-bs-target="#about-tab"
                  role="button"
                  onClick={() => {}}
                >
                  <small>{trans("About")}</small>
                </span>
              </li>
              {window["appConfig"]()["topMenu"]
                ? parse(window["appConfig"]()["topMenu"]())
                : ""}
            </ul>
          </div>
          <div>
            {" "}
            {window["appConfig"]()["topContent"]
              ? parse(window["appConfig"]()["topContent"]())
              : ""}
          </div>
          <div className="ms-auto pe-3">
            <select
              className="form-select form-select-sm"
              style={{ width: "8rem" }}
              value={window["currentLangugage"]}
              onChange={(e) => {
                window.location.href = window["appConfig"]()
                  ["path"]()
                  .concat(e.target.value);
              }}
            >
              {Object.keys(window["availableLangugages"]).map((el) => {
                return (
                  <option value={window["availableLangugages"][el].path}>
                    {window["availableLangugages"][el].label}
                  </option>
                );
              })}
            </select>
          </div>
        </nav>
      </header>
      <Joyride steps={guideTour} continuous={true} />
      <div className="app">
        <div className="tab-content ">
          <div
            className={" tab-pane fade ".concat(
              !getURLPath(1) ? "active show" : ""
            )}
            id="map-tab"
          >
            <div className="d-flex h-100" role="tabpanel">
              <LeftPanel></LeftPanel>
              <div className="h-100 resizable-results-wrapper">
                <Resizable
                  directions={{ bottom: true }}
                  onResize={(e, a) => {
                    window["recaclulatePerfectScrollbarHeight"]();
                    window["map"].updateSize();
                  }}
                  maxHeight="60rem"
                  defaultHeight="calc(100vh - 6rem)"
                  id="resizable-results-panel"
                >
                  <Map></Map>
                  <div
                    className="border-top border-top-2 border-2 border-bottom"
                    style={{ height: "3px" }}
                  ></div>
                </Resizable>

                <ResultsPanel></ResultsPanel>
              </div>
            </div>
          </div>
          <div
            className={"tab-pane fade h-100 ".concat(
              getURLPath(1) === "files" ? "active show" : ""
            )}
            role="tabpanel"
            id="file-tab"
          >
            <FileExplorerComponent></FileExplorerComponent>
          </div>
        </div>

        <ModalComponent
          ref={(refComponent) => {
            window["primaryModal"] = refComponent;
          }}
        ></ModalComponent>
        <ModalComponent
          ref={(refComponent) => {
            window["secondaryModal"] = refComponent;
          }}
        ></ModalComponent>
      </div>
    </>
  );
}

export default App;
